import React from 'react';
import Dashboard from '../../components/Dashboard';
import MenuContainer from '../../components/custom-components/menu/MenuContainer';
import { Box, Stack } from '@chakra-ui/react';
import { PATHS } from '../../router/routes';
import { useQuery } from '@apollo/client';
import { useError } from '../../error-provider/ErrorProvider';
import ZaraButton from '../../components/custom-components/buttons/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetActions, useGetActionsData } from '../../hooks';
import { GetUserAgents } from '../../graphql/queries/GetUserAgents';

const ActionsPage = () => {
    const { showError } = useError();
    const router = useNavigate();

    const { id } = useParams();

    const { data } = useQuery(GetUserAgents, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const agent = data?.getUserAgents?.agents?.find((agent) => agent.id === id);
    const agentId = agent?.id ?? '';

    const actionsData = useGetActionsData(agent);

    const actions = useGetActions(actionsData, agentId);
    return (
        <Dashboard title={PATHS.TRAINING_GUIDE}>
            <MenuContainer>
                <Box
                    p='0px 15px'
                    w={{ base: '100%', sm: '600px' }}
                    css={{
                        '@media only screen and (max-height: 450px)': {
                            width: '600px',
                        },
                    }}
                    mt={{ base: '70px', sm: '90px' }}
                    pb='100px'
                >
                    <Stack spacing='20px' mb='10px'>
                        {actions}
                    </Stack>
                    <ZaraButton w='full' variant='secondary' onClick={() => router(PATHS.MY_AGENT)}>
                        Back
                    </ZaraButton>
                </Box>
            </MenuContainer>
        </Dashboard>
    );
};

export default ActionsPage;
